// Navbar.js
import React, { useEffect, useState } from "react";
import {
    Navbar,
    Container,
    Nav,
    Form,
    FormControl,
    Row,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "../../utils/CartContext";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { logoutUser } from "../../utils/functionFirebase";
import { doc, getDoc } from "firebase/firestore";
import { data } from "../../firebase/firebese";

const NavBar = ({ onSearch }) => {
    const location = useLocation();
    const { cartCount } = useCart();
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setUser(user);
            if (!user) {
                setIsAdmin(false);
                return;
            }
            const userDoc = await getDoc(doc(data, "authentact", user.uid));
            const adminStatus = userDoc.exists() && userDoc.data().isAdmain === true;
            setIsAdmin(adminStatus);
        });
        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        await logoutUser();
        setUser(null);
        // يمكنك إعادة التوجيه إذا أردت
    };

    return (
        <Row>
            <Navbar bg="dark" expand="lg" variant="dark">
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <div className="brand-color ms-3">مطعم البزور</div>
                      
                    </Navbar.Brand>
                        <Nav.Link
                            as={Link}
                            to="/cart"
                            className="d-flex align-items-center gap-1 position-relative"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-basket brand-color" viewBox="0 0 16 16">
                              <path d="M2.31 5.243 8 1l5.69 4.243a.5.5 0 0 1-.58.814L8 2.058 2.89 6.057a.5.5 0 1 1-.58-.814z"/>
                              <path d="M5.5 6.5A.5.5 0 0 1 6 7v1h4V7a.5.5 0 0 1 1 0v1h1.5a.5.5 0 0 1 .5.5v6a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-6a.5.5 0 0 1 .5-.5H4V7a.5.5 0 0 1 1-.5zm-2 2V14.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V8.5H3.5z"/>
                            </svg>
                            <span className="brand-color">المشتريات</span>
                            {cartCount > 0 && (
                              <span style={{position:'absolute',top:0,right:0,background:'#dc3545',color:'#fff',borderRadius:'50%',fontSize:12,padding:'0 6px',minWidth:20,textAlign:'center',transform:'translate(40%,-40%)'}}>
                                {cartCount}
                              </span>
                            )}
                        </Nav.Link>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                        <Nav className="me-auto my-2 my-lg-0" navbarScroll>
                            {user ? (
                                <Nav.Link onClick={handleLogout} className="brand-color text-decoration-none">
                                    تسجيل الخروج
                                </Nav.Link>
                            ) : (
                                <Nav.Link
                                    as={Link}
                                    to="/auth"
                                    className="brand-color text-decoration-none"
                                >
                                    تسجيل الدخول
                                </Nav.Link>
                            )}
                            <Nav.Link
                                as={Link}
                                to="/"
                                className="brand-color text-decoration-none"
                            >
                                الصفحه الرئيسة
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/menu"
                                className="brand-color text-decoration-none"
                            >
                                قائمة الطعام
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/offers"
                                className="brand-color text-decoration-none"
                            >
                                العروض
                            </Nav.Link>
                            {isAdmin && (
                                <Nav.Link
                                    as={Link}
                                    to="/add"
                                    className="brand-color text-decoration-none"
                                >
                                    اضافه منتج
                                </Nav.Link>
                            )}
                            <Nav.Link
                                as={Link}
                                to="/my-orders"
                                className="brand-color text-decoration-none"
                            >
                                طلباتي
                            </Nav.Link>
                            {isAdmin && (
                                <>
                                    <Nav.Link
                                        as={Link}
                                        to="/admin"
                                        className="brand-color text-decoration-none"
                                    >
                                        الأدمن
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/admin-dashboard"
                                        className="brand-color text-decoration-none"
                                    >
                                        لوحة الأدمن
                                    </Nav.Link>
                                </>
                            )}
                        </Nav>

                        {location.pathname === "/menu" && (
                            <Form className="d-flex">
                                <FormControl
                                    type="text"
                                    placeholder="ابحث.."
                                    className="mx-2"
                                    onChange={(e) => onSearch(e.target.value)}
                                />
                                <button className="btn-search">بحث</button>
                            </Form>
                        )}
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Row>
    );
};

export default NavBar;
